import MyContent from './MyContent';

export default MyContent;
